// extracted by mini-css-extract-plugin
export default {"pageTitle":"staff_pageTitle__kc9SN","staffMember":"staff_staffMember__GKmjZ"};